import { Link, type ErrorComponentProps } from "@tanstack/react-router";
import { Compass } from "lucide-react";
import { buttonClass } from "../components/Button";
import { EmptyState } from "../components/EmptyState";
import { ErrorState } from "../components/ErrorState";
import { SkeletonList } from "../components/Skeleton";
import { useT } from "../i18n";

export function RoutePending() {
  return (
    <div className="pt-4">
      <SkeletonList rows={3} />
    </div>
  );
}

/** A chunk that fails to load lands here too, usually after a deploy: trying again fetches the new one. */
export function RouteError({ error, reset }: ErrorComponentProps) {
  return <ErrorState error={error} onRetry={reset} />;
}

export function RouteNotFound() {
  const t = useT();
  return (
    <EmptyState
      icon={<Compass aria-hidden />}
      title={t("notFound.title")}
      description={t("notFound.description")}
      action={
        <Link to="/" className={buttonClass("secondary")}>
          {t("notFound.action")}
        </Link>
      }
    />
  );
}
